import { useState } from 'react';
import { schoolUserApi } from '../api';

export default function ChangePassword() {
  const [form, setForm]         = useState({ newPassword: '', confirmPassword: '' });
  const [showNew, setShowNew]   = useState(false);
  const [showConf, setShowConf] = useState(false);
  const [saving, setSaving]     = useState(false);
  const [msg, setMsg]           = useState(null);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword.length < 6) {
      setMsg({ text: 'Password must be at least 6 characters.', ok: false });
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setMsg({ text: 'Passwords do not match.', ok: false });
      return;
    }
    setSaving(true);
    setMsg(null);
    try {
      const res = await schoolUserApi.changePassword(form);
      if (res.error) {
        setMsg({ text: res.error, ok: false });
      } else {
        window.location.reload();
      }
    } catch (e) {
      setMsg({ text: 'Network error: ' + e.message, ok: false });
    } finally {
      setSaving(false);
    }
  };

  const strength = (pwd) => {
    if (!pwd) return null;
    const checks = [pwd.length >= 8, /[A-Z]/.test(pwd), /[0-9]/.test(pwd), /[^A-Za-z0-9]/.test(pwd)];
    const score = checks.filter(Boolean).length;
    if (score <= 1) return { label: 'Weak', color: '#e53e3e', width: '25%' };
    if (score === 2) return { label: 'Fair', color: '#dd6b20', width: '50%' };
    if (score === 3) return { label: 'Good', color: '#38a169', width: '75%' };
    return { label: 'Strong', color: '#2b6cb0', width: '100%' };
  };

  const str = strength(form.newPassword);

  return (
    <div style={{ maxWidth: 480, margin: '0 auto' }}>
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            <i className="fas fa-key" style={{ marginRight: 8, color: '#0066CC' }}></i>
            Change Password
          </div>
        </div>
        <div className="card-body">

          {msg && (
            <div
              className={msg.ok ? 'success-msg' : 'error-msg'}
              style={{ marginBottom: 16, display: 'flex', alignItems: 'flex-start', gap: 10 }}
            >
              <i className={`fas ${msg.ok ? 'fa-check-circle' : 'fa-exclamation-triangle'}`} style={{ marginTop: 2, flexShrink: 0 }}></i>
              <span>{msg.text}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>

            {/* New Password */}
            <div className="form-group" style={{ marginBottom: 16 }}>
              <label className="form-label">🔒 New Password *</label>
              <div style={{ position: 'relative' }}>
                <input
                  className="form-control"
                  type={showNew ? 'text' : 'password'}
                  value={form.newPassword}
                  onChange={e => set('newPassword', e.target.value)}
                  placeholder="Enter new password"
                  required
                  autoComplete="new-password"
                  style={{ paddingRight: 44 }}
                />
                <button
                  type="button"
                  onClick={() => setShowNew(p => !p)}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#718096', fontSize: 14 }}
                  tabIndex={-1}
                >
                  <i className={`fas ${showNew ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>

              {/* Strength meter */}
              {str && (
                <div style={{ marginTop: 8 }}>
                  <div style={{ height: 5, borderRadius: 3, background: '#e2e8f0', overflow: 'hidden' }}>
                    <div style={{ height: '100%', width: str.width, background: str.color, borderRadius: 3, transition: 'width 0.3s, background 0.3s' }} />
                  </div>
                  <div style={{ fontSize: 12, color: str.color, marginTop: 4, fontWeight: 600 }}>{str.label}</div>
                </div>
              )}

              <div style={{ fontSize: 12, color: '#a0aec0', marginTop: 6 }}>
                Min 6 characters. Use uppercase, numbers and symbols for a stronger password.
              </div>
            </div>

            {/* Confirm Password */}
            <div className="form-group" style={{ marginBottom: 24 }}>
              <label className="form-label">✅ Confirm New Password *</label>
              <div style={{ position: 'relative' }}>
                <input
                  className="form-control"
                  type={showConf ? 'text' : 'password'}
                  value={form.confirmPassword}
                  onChange={e => set('confirmPassword', e.target.value)}
                  placeholder="Repeat new password"
                  required
                  autoComplete="new-password"
                  style={{
                    paddingRight: 44,
                    borderColor: form.confirmPassword && form.confirmPassword !== form.newPassword ? '#e53e3e' : undefined,
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowConf(p => !p)}
                  style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#718096', fontSize: 14 }}
                  tabIndex={-1}
                >
                  <i className={`fas ${showConf ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
              {form.confirmPassword && form.confirmPassword !== form.newPassword && (
                <div style={{ fontSize: 12, color: '#e53e3e', marginTop: 4 }}>
                  <i className="fas fa-times-circle" style={{ marginRight: 4 }}></i>Passwords do not match
                </div>
              )}
              {form.confirmPassword && form.confirmPassword === form.newPassword && (
                <div style={{ fontSize: 12, color: '#38a169', marginTop: 4 }}>
                  <i className="fas fa-check-circle" style={{ marginRight: 4 }}></i>Passwords match
                </div>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={saving}
              style={{ width: '100%', padding: '12px', fontSize: 15, fontWeight: 700, justifyContent: 'center' }}
            >
              {saving
                ? <><i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }}></i>Updating…</>
                : <><i className="fas fa-key" style={{ marginRight: 8 }}></i>Change Password</>
              }
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
